module.exports = __webpack_public_path__ + "img/jiagou.df5a751f.png";